<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="500px" persistent>
    <v-card v-if="student">
      <v-card-title>
        <span class="headline">Inscribir a Clínica</span>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog" class="cursor-pointer">mdi-close</v-icon>
      </v-card-title>

      <v-card-text>
        <!-- Alumno -->
        <v-row class="mb-4">
          <v-col cols="12">
            <v-alert type="info" outlined>
              <strong>{{ student.name }}</strong>
              <div class="caption mt-1">Nivel: {{ getLevelLabel(student.level) }}</div>
            </v-alert>
          </v-col>
        </v-row>

        <!-- Clínicas Disponibles -->
        <v-row>
          <v-col cols="12">
            <div class="subtitle-2 font-weight-bold mb-3">Selecciona una Clínica</div>
            <v-select
              v-model="selectedClinic"
              :items="availableClinics"
              item-text="description"
              item-value="id"
              outlined
              dense
              label="Clínica"
            >
              <template v-slot:item="{ item }">
                <div class="d-flex justify-space-between" style="width: 100%;">
                  <span>{{ item.description }}</span>
                  <v-chip x-small color="primary" text-color="white">
                    {{ item.enrolled }}/{{ item.capacity }}
                  </v-chip>
                </div>
              </template>
              <template v-slot:selection="{ item }">
                <span>{{ item.description }}</span>
              </template>
            </v-select>
          </v-col>
        </v-row>

        <!-- Detalles de la Clínica Seleccionada -->
        <v-row v-if="selectedClinicData" class="mt-4">
          <v-col cols="12">
            <v-card outlined class="pa-3">
              <div class="subtitle-2 font-weight-bold mb-2">Detalles de la Clínica</div>
              <div class="d-flex justify-space-between mb-2">
                <span class="caption grey--text">Tipo:</span>
                <span class="caption font-weight-bold">{{ getClinicTypeLabel(selectedClinicData.type) }}</span>
              </div>
              <div class="d-flex justify-space-between mb-2">
                <span class="caption grey--text">Fecha:</span>
                <span class="caption font-weight-bold">{{ formatDate(selectedClinicData.date) }}</span>
              </div>
              <div class="d-flex justify-space-between mb-2">
                <span class="caption grey--text">Hora:</span>
                <span class="caption font-weight-bold">{{ selectedClinicData.time }}</span>
              </div>
              <div class="d-flex justify-space-between">
                <span class="caption grey--text">Disponibilidad:</span>
                <span class="caption font-weight-bold">
                  {{ selectedClinicData.capacity - selectedClinicData.enrolled }}/{{ selectedClinicData.capacity }}
                </span>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Capacidad -->
        <v-row v-if="selectedClinicData" class="mt-4">
          <v-col cols="12">
            <v-progress-linear
              :value="(selectedClinicData.enrolled / selectedClinicData.capacity) * 100"
              height="6"
              class="mb-2"
              :color="getCapacityColor(selectedClinicData.enrolled, selectedClinicData.capacity)"
            ></v-progress-linear>
            <div v-if="selectedClinicData.enrolled === selectedClinicData.capacity" class="caption red--text">
              ⚠ Esta clínica está llena
            </div>
            <div v-else class="caption green--text">
              ✓ Hay espacio disponible
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">Cancelar</v-btn>
        <v-btn
          color="primary"
          text
          @click="submit"
          :disabled="!selectedClinic || isFull"
        >
          Inscribir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EnrollmentDialog',
  props: {
    dialog: Boolean,
    student: Object,
    availableClinics: Array
  },
  data () {
    return {
      selectedClinic: null
    }
  },
  computed: {
    selectedClinicData () {
      if (!this.selectedClinic) return null
      return this.availableClinics.find(c => c.id === this.selectedClinic)
    },
    isFull () {
      return this.selectedClinicData && this.selectedClinicData.enrolled >= this.selectedClinicData.capacity
    }
  },
  watch: {
    dialog (newVal) {
      if (newVal) {
        this.selectedClinic = null
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('update:dialog', false)
    },
    submit () {
      if (this.selectedClinic && !this.isFull) {
        this.$emit('enroll', this.selectedClinic)
        this.closeDialog()
      }
    },
    formatDate (dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString('es-MX', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    },
    getLevelLabel (level) {
      const labels = {
        basico: 'Básico',
        intermedio: 'Intermedio',
        avanzado: 'Avanzado'
      }
      return labels[level] || 'Otro'
    },
    getClinicTypeLabel (type) {
      const labels = {
        swing: 'Swing',
        putting: 'Putting',
        pitch: 'Pitch',
        full_swing: 'Swing Completo',
        short_game: 'Juego Corto'
      }
      return labels[type] || 'Otro'
    },
    getCapacityColor (enrolled, capacity) {
      const percentage = (enrolled / capacity) * 100
      if (percentage >= 100) return 'red'
      if (percentage >= 75) return 'orange'
      return 'green'
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
